<template>
  <section class="main">
    <div class="heading">
      <img class="heading__icon" src="@/assets/icon-device-sidebar.svg" />
      <div>
        <h1 class="heading__title">
          <img
            class="heading__title-icon"
            src="@/assets/icon-device-sidebar.svg"
          />{{ $t("LINK_DEVICE", { device: deviceStr }) }}
        </h1>
        <p
          class="heading__text"
          v-html="$t('LINK_DEVICE_DESC', { device: deviceStr })"
        ></p>
      </div>
    </div>
    <form class="form">
      <label class="form__label">{{ $t("PLEASE_ENTER_YOUR_EMAIL") }}:</label>
      <div class="form__group g-code">
        <input
          v-model="email"
          placeholder="user@example.com"
          type="email"
          class="g-code__input"
        />
        <button
          type="submit"
          class="g-code__button"
          :class="{ 'g-code__button_loading': this.isLoading }"
          @click.prevent="link"
        >
          <span class="g-code__loader"></span>
          <img class="g-code__icon" src="@/assets/icon-device.svg" />
          {{ $t("LINK_YOUR_DEVICE") }}
        </button>
      </div>
    </form>
    <div class="actions">
      <span v-if="!isMobile" class="actions__helper">{{
        $t("TO_LINK_IPHONE_DESC")
      }}</span>
      <span class="actions__link">{{ $t("TO_LINK_TV_DESC") }}</span>
    </div>
    <div class="video">
      <h2 class="video__heading">{{ $t('VIDEO_TUTORIAL') }}. <a href="https://www.youtube.com/watch?v=LWy51S2piqE&list=PL4Ena5DQT65Jtm0ux3-JYvBmNjn4ei5zs" target="_blank">{{ $t('ALL_VIDEO_TUTORIALS') }}</a></h2>
      <div class="video__wrapper">
        <!-- isMobile ? 'rPW2ntD3_ZQ' : 'KaZ1-uxzPmk'-->
        <iframe
          class="video__iframe"
          :src="
            `https://www.youtube.com/embed/${
              'LWy51S2piqE'
            }`
          "
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  </section>
</template>

<script>
import isItselfLinkable from '@/utils/isItselfLinkable';

export default {
  data() {
    return {
      isMobile: isItselfLinkable(),
      email: '',
      isLoading: false,
    };
  },
  computed: {
    isDeviceLinked() {
      return this.$store.getters.isDeviceLinked;
    },
    title() {
      return this.$t('LINK_A_DEVICE');
    },
    deviceStr() {
      return this.isMobile ? 'iPhone/iPad/iPod/Apple Silicon Mac' : 'PC/Intel Mac';
    },
  },
  watch: {
    isDeviceLinked(val) {
      if (val) {
        this.$router.push('/my/devices');
      }
    },
  },
  methods: {
    checkDevices() {
      setTimeout(async () => {
        await Promise.allSettled([this.$store.dispatch('getDevices', false), this.$store.dispatch('getConfig', false)]);

        const { devices } = this.$store.getters;
        if (devices.length > 0) {
          this.$router.push('/');
          return;
        }

        this.checkDevices();
      }, 1000);
    },
    link() {
      if (!/^\S+@\S+\.\S+$/.test(this.email)) {
        this.$notify({
          type: 'error',
          text: this.$t('INVALID_EMAIL'),
        });
        return;
      }

      this.isLoading = true;
      const type = this.isMobile ? 'new' : 'control';
      this.$api.link({
        email: this.email,
        type,
      })
        .then((response) => {
          if (response.errors.length && response.errors[0].code === 'ERROR_PROCEED_TO_EMAIL') {
            this.$router.push({
              name: 'success',
              params: {
                message: response.errors[0].translated,
                link: '/',
                linkText: 'GO_TO_MAIN_PAGE',
              },
            });
            return;
          }

          if (response.success) {
            this.$router.push({
              name: 'success',
              params: {
                message: this.$t('YOUR_DEVICE_BEING_LINKED'),
                link: '/',
                linkText: this.$t('GO_TO_MAIN_PAGE'),
              },
            });
            if (response.data.link_token) {
              this.$store.commit('lt', response.data.link_token);
            }
            if (response.data.profile_service) {
              this.checkDevices();
              window.setTimeout(() => {
                window.location.href = response.data.profile_service;
              }, 1000);
            }
          } else {
            this.$router.push({
              name: 'error',
              params: {
                message: response.errors[0].translated,
              },
            });
          }
          this.isLoading = false;
        });
    },
  },
  beforeCreate() {
    if (this.$store.getters.isDeviceLinked) {
      this.$router.push('/my/devices');
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables";

.main {
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
}

.heading {
  display: flex;

  &__icon {
    flex: 0 0 130px;
    height: auto;
    margin-right: 30px;

    @include notebook {
      display: none;
    }
  }

  &__title {
    color: var(--text-tertiary);
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 15px;

    @include notebook {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      font-size: 16px;
    }

    &-icon {
      display: none;

      @include notebook {
        display: block;
        width: 24px;
        height: 16px;
        margin-right: 8px;
      }
    }
  }

  &__text {
    line-height: 20px;
  }
}

.form {
  background: var(--bg);
  border: 1px solid #ebebeb;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  padding: 20px 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 25px 0 15px;

  @include notebook {
    margin: 10px 0 10px;
    text-align: center;
  }

  &__group {
    margin-top: 10px;
    width: 100%;
    max-width: 410px;
  }
}

.actions {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  text-align: center;

  @include notebook {
    margin-bottom: 10px;
  }

  &__helper {
    background: var(--tertiary-accent);
    border-radius: 2px;
    padding: 4px;
  }

  &__link {
    background: var(--bg-warning);
    border-radius: 2px;
    padding: 4px;
    color: #3d464d;
    font-weight: 400;
    flex-grow: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 5px;

    &:before {
      content: "";
      display: none;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 5px 0 5px 5px;
      border-color: transparent transparent transparent $text-secondary;
      margin-right: 6px;
    }
  }
}

.video {
  padding-top: 20px;
  border-top: 1px solid #e5e5e5;

  @include notebook {
    padding-top: 10px;
  }

  &__heading {
    color: var(--text-tertiary);
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 15px;

    @include notebook {
      font-size: 14px;
      margin-bottom: 10px;
    }
  }

  &__wrapper {
    padding-bottom: 56.25%;
    position: relative;
  }

  &__iframe {
    display: block;
    border: none;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
